// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  isUnit?:string;
};

export default function RHFTextField({ name, helperText,isUnit, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          value={typeof field.value === 'number' && field.value === 0  ? 0 : field.value}
          error={!!error}
          InputProps={isUnit?{
            endAdornment: <InputAdornment position="end">{isUnit}</InputAdornment>,
          }:{}}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
}
